<template>
  <div>
    <v-container grid-list-md>
      <v-card>
        <v-card-text>
          <v-layout align-center justify-start row fill-height>
            <v-flex md5>
              <v-select
                v-model="subject"
                :items="usersArray"
                item-text="name"
                item-value="id"
                label="対象者"
                return-object
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-start row fill-height>
            <v-flex md1>性別: {{subject.sex}}</v-flex>
            <v-flex md2>生年月日: {{toDate(subject.birth)}}</v-flex>

            <v-flex md3>職種:{{subject.job}}</v-flex>
            <v-flex md2>役職:{{subject.position}}</v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.stop="createItem">追加</v-btn>

          <v-btn @click.stop="closeDialog">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import { unixtimeToJapaneseFormattedDate } from "@/utils/datetime.js";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  props: {
    target_id: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      userDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("users"),
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("challenge_sheets"),
      users: {},
      usersArray: [],
      subject: {},
      items: [],
      keysCopyToSheet: ["birth", "job", "job_id", "position"]
    };
  },
  watch: {},
  mounted() {
    this.getUsers();
  },
  computed: {},
  methods: {
    async getUsers() {
      this.users = {};
      this.usersArray = [];
      const querySnapshot = await this.userDbRef.get();
      querySnapshot.forEach(doc => {
        const user = doc.data();
        this.users[doc.id] = { ...user, id: doc.id };
        this.usersArray.push({ ...user, id: doc.id });
      });
    },
    toDate(unixtime) {
      return Number.isInteger(unixtime)
        ? unixtimeToJapaneseFormattedDate(unixtime)
        : "";
    },
    async createItem() { 
      const item = {
        target_id:this.target_id,
        status:"未記入",
        plans: [
          {
            approve_comment: "",
            approve_status: false,
            method: "",
            plan: "",
            rater_comment: "",
            rater_comment: "",
            self_point: "",
            self_comment: ""
          },
          {
            approve_comment: "",
            approve_status: false,
            method: "",
            plan: "",
            rater_comment: "",
            rater_comment: "",
            self_point: "",
            self_comment: ""
          },
          {
            approve_comment: "",
            approve_status: false,
            method: "",
            plan: "",
            rater_comment: "",
            rater_comment: "",
            self_point: "",
            self_comment: ""
          }
        ]
      };
      item.user_id = this.subject.id;
      item.name = this.subject.name;
      for (let key of this.keysCopyToSheet) {
        item[key] = this.subject[key];
      }
      this.$emit('createItem', item)
      this.subject={}
      
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    toChallangeSheet(item){
            this.$router.push({ name: "manage_survey", params: { company_id: this.$route.params.company_id, survey_id: s.id } })

    },
    ...mapActions("app", ["changeLoadingState"])
  }
};
</script>

<style lang="scss" scoped>
</style>
